var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.29 20.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E-learning-en-speelplaats"
  }, /*#__PURE__*/React.createElement("g", {
    id: "E-learning-zoeken-1ste-opengeklapt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "cls-1",
    d: "m3.7,8.62c-.79.79-.79,2.07,0,2.87h0l6.15,6.15c.57.55.58,1.46.03,2.03-.55.57-1.46.59-2.03.03-.01-.01-.02-.02-.03-.03L1.25,13.09c-1.67-1.68-1.67-4.4,0-6.08L7.83.44c.55-.57,1.46-.59,2.03-.04.57.55.58,1.46.03,2.03-.01.01-.02.02-.03.04l-6.15,6.15Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandLeft);
export default __webpack_public_path__ + "static/media/expand-left.a2a18dc9.svg";
export { ForwardRef as ReactComponent };